import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled, { keyframes } from 'styled-components';
import * as grid from '@helpcenter/styles/src/grid';
import * as mixins from '@helpcenter/styles/src/mixins';
import { range } from 'lodash';
import { token } from '@atlaskit/tokens';

interface LoadingSkeletonProps {
	height: number;
	backgroundColor: string;
}

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Container = styled.div`
	${mixins.flexCenter};
	padding: ${token('space.100', '8px')};
	flex-direction: column;
	pointer-events: none;
	flex: 1 1 auto;
`;

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const AbsoluteFillContainer = styled(Container)`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
`;

const fromPositionX = -400;
const toPositionX = 800;

const shimmer = keyframes({
	'0%': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
		backgroundPosition: `${fromPositionX}px 0`,
	},
	'100%': {
		backgroundPosition: `${toPositionX}px 0`,
	},
});

/** Simple loading skeleton block with subtle animated white shimmering effect */
// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const LoadingSkeleton = styled.div<LoadingSkeletonProps>`
	${mixins.borderRadius};

	height: ${(props) => `${props.height}px`};

	background-color: ${(props) => props.backgroundColor};
	background-image: linear-gradient(
		to right,
		${(props) => props.backgroundColor} 10%,
		${token('elevation.surface', '#FFFFFF')} 40%,
		${(props) => props.backgroundColor} 50%
	);
	background-repeat: no-repeat;

	animation-duration: 0.8s;
	animation-fill-mode: forwards;
	animation-iteration-count: infinite;
	animation-name: ${shimmer};
	animation-timing-function: ease-in;
`;

// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const FieldSkeletonWrapper = styled.div`
	${mixins.borderRadius};
	border: ${token('border.width.selected', '2px')} solid;
	border-color: ${token('color.border', '#DFE1E6')};
`;

export const FieldLoadingSkeleton = () => (
	<FieldSkeletonWrapper>
		<LoadingSkeleton height={150} backgroundColor={token('color.skeleton.subtle', '#FAFBFC')} />
	</FieldSkeletonWrapper>
);

// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const AvatarSkeletonWrapper = styled.div`
	min-width: ${grid.multiple(4.5).px};
	border-radius: 50%;
	overflow: hidden;
`;

export const AvatarLoadingSkeleton = () => (
	<AvatarSkeletonWrapper>
		<LoadingSkeleton height={36} backgroundColor={token('color.skeleton', '#EBECF0')} />
	</AvatarSkeletonWrapper>
);

// eslint-disable-next-line rulesdir/styled-component-order, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const TextFieldLoadingSkeletonWrapper = styled.div`
	margin-top: ${token('space.500', '40px')};
	margin-bottom: ${token('space.500', '40px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, rulesdir/styled-component-order, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const SkeletonContainer = styled.div`
	width: 100%;
`;

export const TextFieldLoadingSkeleton = ({ shortText }: { shortText: boolean }) => {
	return (
		<TextFieldLoadingSkeletonWrapper>
			<LoadingSkeleton
				height={shortText ? grid.multiple(5).unitless : grid.multiple(22).unitless}
				backgroundColor={token('color.skeleton.subtle', '#F4F5F7')}
			/>
		</TextFieldLoadingSkeletonWrapper>
	);
};

// 3 short text fields, 1 long text field, then another short text field
export const LoadingSkeletonFields = () => {
	return (
		<>
			<SkeletonContainer>
				{range(3).map((ndx) => (
					<TextFieldLoadingSkeleton key={ndx} shortText />
				))}
				<TextFieldLoadingSkeleton shortText={false} />
				<TextFieldLoadingSkeleton shortText />
			</SkeletonContainer>
		</>
	);
};
